import React from "react"
import PropTypes from "prop-types"
import DOMPurify from "dompurify"

const Header = ({ name, description, children }) => {
  const withLineBreaks = DOMPurify.sanitize(description, {
    FORBID_TAGS: ["img", "figure", "figcaption"],
    FORBID_CONTENTS: ["figure", "figcaption"],
    ADD_ATTR: ["target"],
    FORCE_BODY: true,
  })

  return (
    <header>
      <h1 className="h1">{name}</h1>
      {children}
      {description && (
        <div
          className="fs-3 c-tint0"
          data-testid="header-description"
          dangerouslySetInnerHTML={{
            __html: withLineBreaks.replace(/\n/g, "<br />"),
          }}
        ></div>
      )}
    </header>
  )
}

Header.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node,
}

export default Header
